module.exports = __webpack_public_path__ + "static/media/bg.7467c9e3.png";